<template lang='pug'>
  flex#contact.view.centered( @submit.prevent='send' )
    contact-form( :contact='contact' )
</template>

<script>
  import { db } from '@/main'
  import ContactForm from '@/components/forms/contact/standard'
  import Flex from '@/components/containers/flex'

  export default {
    name: 'contact.view',

    components: {
      ContactForm,
      Flex
    },

    data() {
      return {
        contact: {}
      }
    }
    // data() {
    //   return{
    //     action: 'Send',
    //     email: '',
    //     name: '',
    //     message: '',
    //   }
    // },

    // methods: {
    //   update(email) {
    //     this.email = email
    //   },

    //   send() {
    //     this.action = 'Sending...'

    //     db.collection('contacts').add({
    //       email: this.email,
    //       name: this.name,
    //       message: this.message
    //     }).then( snap => {
    //       this.action = 'Got it. Thanks!'
    //       setTimeout( () => {
    //         this.action = 'Send'
    //         this.email = ''
    //         this.name = ''
    //         this.message = ''
    //       }, 2400)
    //     }).catch( e => console.log(e) )
    //   }
    // },

    // created() {
    // }
  }

</script>

<style scoped lang='stylus'>
  #contact
    height 100%
    width 100%
</style>
